import { render, staticRenderFns } from "./SurchargeBanner.vue?vue&type=template&id=2c1017c1"
import script from "./SurchargeBanner.vue?vue&type=script&lang=ts"
export * from "./SurchargeBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports